import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id FD1999E4-4780-48E5-8F18-606871BA0581
 * name video-4k-box
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-4k-box.svg
 * tags
 * - Video / Movie 
 */
export const Video4kBoxIcon = createSvgIcon(<><path d="M19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M12,13.5H11V15H9.5V13.5H6.5V9H8V12H9.5V9H11V12H12V13.5M18,15H16.2L14.4,12.8V15H13V9H14.5V11.2L16.2,9H18L15.8,12L18,15Z" /></>, 'Video4kBoxIcon');
export default Video4kBoxIcon